import { LocationMap } from './LocationMap';
import { locationData, yandexEntranceRouteUrl } from './locationData';
import { analyticsGoals, trackAnalyticsGoal } from '../../lib/analytics/yandexMetrika';
import styles from './LocationSection.module.scss';

export function LocationSection() {
  return (
    <section className={styles.section} id="infrastructure" aria-labelledby="location-title">
      <div id="location" className={styles.compatibilityAnchor} aria-hidden="true" />
      <header className={styles.header} data-reveal>
        <div className={styles.heading}>
          <p className={styles.eyebrow}>Расположение и инфраструктура</p>
          <h2 id="location-title">Всё необходимое — рядом</h2>
        </div>
        <p className={styles.lead}>
          Лучезарная Долина находится в деревне Низино — рядом с повседневной инфраструктурой и всего в трёх
          километрах от КАД. 
        </p>
      </header>

      <div className={styles.mapStage}>
        <LocationMap />

        <aside className={styles.summary} aria-labelledby="directions-title" data-reveal>
          <p className={styles.summaryEyebrow}>Навигация</p>
          <h3 id="directions-title">На автомобиле</h3>
          <ul className={styles.directions}>
            {locationData.directions.map(({ time, destination }) => (
              <li key={destination}>
                <strong>{time}</strong>
                <span>{destination}</span>
              </li>
            ))}
          </ul>
          {/* <p className={styles.note}>
            Время в пути зависит от дорожной обстановки.
          </p> */}
          <div className={styles.actions}>
            <a
              className={styles.routeLink}
              href={yandexEntranceRouteUrl}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackAnalyticsGoal(analyticsGoals.routeClick)}
            >
              Построить маршрут
            </a>
            <a
              className={styles.mapLink}
              href={locationData.mapLink}
              target="_blank"
              rel="noreferrer"
            >
              Открыть в Яндекс Картах
            </a>
          </div>
        </aside>
      </div>

      <div className={styles.context}>
        <article className={styles.infrastructure} data-reveal>
          <p className={styles.contextIndex}>01 · Низино</p>
          <h3>В пешей доступности</h3>
          <p className={styles.contextLead}>
            Повседневная инфраструктура находится рядом с посёлком и доступна без поездки в Петергоф
            или Санкт-Петербург.
          </p>
          <ul className={styles.infrastructureList}>
            {locationData.infrastructure.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>

        <article className={styles.transport} data-reveal data-reveal-delay="1">
          <p className={styles.contextIndex}>02 · Транспорт</p>
          <h3>Общественный транспорт</h3>
          <p className={styles.contextLead}>
            Через Низино проходят маршруты до Нового и Старого Петергофа, Ломоносова и станции метро
            «Проспект Ветеранов». Автобус №360 следует до железнодорожной станции Новый Петергоф.
          </p>
          <div className={styles.transportFact}>
            <strong>{locationData.publicTransportRoutes.join(' · ')}</strong>
            <p>Номера основных маршрутов через Низино.</p>
          </div>
        </article>
      </div>
    </section>
  );
}
